import { render } from "./BaseDropdownItem.vue?vue&type=template&id=4b8be3c2&scoped=true"
import script from "./BaseDropdownItem.vue?vue&type=script&lang=js"
export * from "./BaseDropdownItem.vue?vue&type=script&lang=js"

import "./BaseDropdownItem.vue?vue&type=style&index=0&id=4b8be3c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8be3c2"]])

export default __exports__